import { render, staticRenderFns } from "./ManualNotificationContainer.vue?vue&type=template&id=f214cec8&"
import script from "./ManualNotificationContainer.vue?vue&type=script&lang=js&"
export * from "./ManualNotificationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports